import {PrismConfigOptions} from '../environment-variables.interface';

export const baseLocalConfig: PrismConfigOptions = {
  environmentName: "Prism Local Environment",
  hubApi: 'http://localhost:8180',
  ionicEnvName: 'local',
  loginFormLogo: './assets/logos/cbsi-logo.png',
  loginLogoClass: 'baseLogo',
  loginPageClass: 'baseLoginPageBackground',
  logoColor: 'black',
  siteId: 1,
  enabledContentFeatures: {
    article: {
      create: true,
      edit: true,
      listing: true,
    },
    image: {
      create: true,
      edit: true,
      listing: true,
    },
    video: {
      create: true,
      edit: true,
      listing: true,
      upload: true,
    },
  },
  requiredFields: {
    content_article: {
      draft: ['slug', 'headline', 'editions'],
      publish: ['slug', 'headline', 'editions'],
      schedule: ['slug', 'headline', 'editions'],
      preview: ['slug', 'headline', 'editions'],
    },
    content_video: {
      draft: ['slug', 'headline', 'editions'],
      publish: ['slug', 'headline', 'editions'],
      schedule: ['slug', 'headline', 'editions'],
      preview: ['slug', 'headline', 'editions'],
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/environment-variables/base/local.config.ts